import { Close } from "@mui/icons-material";
import { Button } from "@mui/material";
import React, { useCallback, useContext, useMemo } from "react";

import { UserGuides } from "constants/constants";
import { SLAPSHOT_CAMERA_TRACKING_GUIDE_URL } from "constants/urls";
import { UserContext } from "layouts/SlapshotMainLayout";

import styles from "./TrackingOutputGuide.module.scss";

const TrackingOutputGuide = () => {
  const user = useContext(UserContext);
  const tips = useMemo(
    () => user?.preferences?.tips || [],
    [user?.preferences?.tips],
  );
  const showTip =
    user?.preferences !== undefined &&
    !tips.includes(UserGuides.TrackingOutputGuide) &&
    !user?.preferences?.hideTips;

  const onClose = useCallback(() => {
    user?.setPreferences("tips", UserGuides.TrackingOutputGuide, true);
  }, [user]);

  if (!showTip) {
    return null;
  }

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <div className={styles.title}>Not happy with this output?</div>

        <div onClick={onClose}>
          <Close fontSize="small" className={styles.close} />
        </div>
      </div>

      <div className={styles.description}>
        Click here to view our guide on the best practices for camera tracking.
      </div>

      <Button
        className={styles.button}
        onClick={() => {
          window.open(SLAPSHOT_CAMERA_TRACKING_GUIDE_URL, "_blank");
        }}
      >
        Go to guide
      </Button>
    </div>
  );
};

export default TrackingOutputGuide;
